var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBitka(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25,
    fill: "#FAF3F3",
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9_221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5454 32.6069C13.5454 31.7762 14.2189 31.1028 15.0496 31.1028V31.1028C15.8803 31.1028 16.5537 31.7762 16.5537 32.6069V38.4959C16.5537 39.3266 15.8803 40 15.0496 40V40C14.2189 40 13.5454 39.3266 13.5454 38.4959V32.6069Z",
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7107 31.6262C17.7107 31.3371 17.9179 31.1028 18.1735 31.1028H20.2562C20.5118 31.1028 20.719 31.3371 20.719 31.6262V39.4766C20.719 39.7657 20.5118 40 20.2562 40H18.1735C17.9179 40 17.7107 39.7657 17.7107 39.4766V31.6262Z",
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5454 18.5421H20.719V31.6262H13.5454V18.5421Z",
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0496 18.5421V20.7664V20.7664C14.0272 20.7664 13.1983 21.5952 13.1983 22.6176V31.4953H11V24.1682V22.5916C11 20.3551 12.8131 18.5421 15.0496 18.5421V18.5421Z",
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0992 18.5421V20.7664V20.7664C20.1216 20.7664 20.9504 21.5952 20.9504 22.6176V31.4953H23.1488V24.1682V22.5916C23.1488 20.3551 21.3357 18.5421 19.0992 18.5421V18.5421Z",
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.1322,
    cy: 15.0093,
    rx: 2.66116,
    ry: 3.00935,
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3967 32.6069C31.3967 31.7762 32.0701 31.1028 32.9008 31.1028V31.1028C33.7315 31.1028 34.405 31.7762 34.405 32.6069V38.4959C34.405 39.3266 33.7315 40 32.9008 40V40C32.0701 40 31.3967 39.3266 31.3967 38.4959V32.6069Z",
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.562 31.6262C35.562 31.3371 35.7692 31.1028 36.0248 31.1028H38.1074C38.363 31.1028 38.5703 31.3371 38.5703 31.6262V39.4766C38.5703 39.7657 38.363 40 38.1074 40H36.0248C35.7692 40 35.562 39.7657 35.562 39.4766V31.6262Z",
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3967 18.5421H38.5703V31.6262H31.3967V18.5421Z",
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9008 18.5421V20.7664V20.7664C31.8784 20.7664 31.0496 21.5952 31.0496 22.6176V31.4953H28.8512V24.1682V22.5916C28.8512 20.3551 30.6643 18.5421 32.9008 18.5421V18.5421Z",
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9504 18.5421V20.7664V20.7664C37.9728 20.7664 38.8017 21.5952 38.8017 22.6176V31.4953H41V24.1682V22.5916C41 20.3551 39.1869 18.5421 36.9504 18.5421V18.5421Z",
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.9835,
    cy: 15.0093,
    rx: 2.66116,
    ry: 3.00935,
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.2645,
    cy: 28.3107,
    rx: 0.619835,
    ry: 0.815534,
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26,
    cy: 28.3107,
    rx: 0.619835,
    ry: 0.815534,
    fill: "#FF7878"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.7355,
    cy: 28.3107,
    rx: 0.619835,
    ry: 0.815534,
    fill: "#FF7878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9_221",
    x: 7,
    y: 12,
    width: 38,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_221"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_221",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitka);
export default __webpack_public_path__ + "static/media/Bitka.0cd21dcacccc40e7f70d29b013530de5.svg";
export { ForwardRef as ReactComponent };